import { useEffect, useState, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import { InputSwitch } from 'primereact/inputswitch';
import { Checkbox } from 'primereact/checkbox';
import { getRoles, getRoleById, createRole, updateRole, deleteRole } from '../../Service/UserService';
import { useForm } from 'react-hook-form';
import Overlay from '../../Components/Overlay';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';

const { $ } = window;

const RolePage = () => {
    const tableRoles = useRef();
    const [state, setStates] = useState({
        _id: undefined,
        salesorder: false,
        salesorderapproval: false,
        purchaseorder: false,
        delivery: false,
        inventorytransfer: false,
        operationalcost: false,
        withdrawal: false,
        user: false,
        role: false,
        productstock: false,
        is_active: true,
        name: '',
        is_view: false
    });

    const setState = data => {
        setStates({ ...state, ...data });
    }

    const columns = [
        { id: 1, title: 'Name', field: 'name', sortable: true },
        /*{ id: 2, title: 'Active', field: 'is_active', sortable: true, render: data => (<InputSwitch checked={data.is_active} />) },*/
        {
            id: 3, title: 'Action', field: 'name', width: 150, render: (item) => (
                <div>
                    <button type='button' className='btn text-primary' onClick={onViewClick(item)}><i className="fa fa-eye"></i> View</button>
                    <button type='button' className='btn text-success' onClick={onEditClick(item)}><i className="fa fa-edit"></i> Edit</button>
                    <button type='button' className='btn text-danger' onClick={onDeleteClick(item)}><i className="fa fa-trash"></i> Delete</button>
                </div>
            )
        }
    ];

    const onViewClick = item => () => {
        const { name, is_active, privileges, _id } = item;
        const _role = { name, is_active, _id, is_view: true };
        privileges.forEach(e => {
            _role[e.name] = e.access;
        });
        setState(_role);
        $('#modal-form').modal();
    }

    const onEditClick = item => () => {
        const { name, is_active, privileges, _id } = item;
        const _role = { name, is_active, _id, is_view: false };
        privileges.forEach(e => {
            _role[e.name] = e.access;
        });
        setState(_role);
        $('#modal-form').modal();
    }

    const onDeleteClick = item => () => {
        Swal.fire(
            {
                icon: 'question',
                title: 'Are you sure?',
                text: 'Deleted role can not be restored!',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
            }
        ).then(({ isConfirmed }) => {
            if (isConfirmed) {
                setState({ processing: true })
                deleteRole(item._id).then(res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: `Delete role success!`
                    }).then(res => {
                        tableRoles.current.refresh();

                    });
                }).catch(({ response }) => {
                    const { message } = response?.data;
                    Swal.fire({
                        icon: 'error',
                        title: `Delete role error!`,
                        text: message
                    });
                }).finally(() => {
                    setState({ processing: false })
                })
            }
        })
    }

    const onAddData = () => {
        const _role = {
            _id: undefined,
            name: '',
            is_active: true,
            salesorder: false,
            salesorderapproval: false,
            purchaseorder: false,
            delivery: false,
            inventorytransfer: false,
            operationalcost: false,
            withdrawal: false,
            user: false,
            role: false,
            productstock: false,
            processing: false,
            is_view: false
        };
        setState(_role);
        $('#modal-form').modal();
    }

    const onChange = e => {
        const { name, checked } = e.target;
        setState({ [name]: checked })
    }

    const onNameChange = e => {
        setState({ name: e.target.value })
    }

    const onSwitchChange = e => {
        setState({ is_active: e.target.value })
    }

    const onSubmit = () => {
        const payload = {
            name,
            is_active,
            privileges: [
                {
                    name: 'salesorder',
                    path: '/salesorder',
                    access: salesorder
                },
                {
                    name: 'salesorderapproval',
                    path: '/salesorder/approval',
                    access: salesorderapproval
                },
                {
                    name: 'purchaseorder',
                    path: '/purchaserder',
                    access: purchaseorder
                },
                {
                    name: 'delivery',
                    path: '/delivery',
                    access: delivery
                },
                {
                    name: 'inventorytransfer',
                    path: '/inventorytransfer',
                    access: inventorytransfer
                },
                {
                    name: 'operationalcost',
                    path: '/operationalcost',
                    access: operationalcost
                },
                {
                    name: 'withdrawal',
                    path: '/payment-gateway/withdrawal',
                    access: withdrawal
                },
                {
                    name: 'user',
                    path: '/users',
                    access: user
                },
                {
                    name: 'role',
                    path: '/roles',
                    access: role
                },
                {
                    name: 'productstock',
                    path: '/productstock/branch',
                    access: productstock
                },
            ]
        }
        const request = _id ? updateRole(_id, payload) : createRole(payload);
        setState({ processing: true })
        request.then(res => {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: `${(_id ? 'Update' : 'Create')} role success!`
            }).then(res => {
                $('#modal-form').modal('hide');
                tableRoles.current.refresh();

            });
        }).catch(({ response }) => {
            const { message } = response?.data;
            Swal.fire({
                icon: 'error',
                title: `${(_id ? 'Update' : 'Create')} role error!`,
                text: message
            });
        }).finally(() => {
            setState({ processing: false })
        })
    }

    const propsTable = { columns, getData: getRoles, showIndex: true, showAddButton: true, onAddData };
    const { name, is_active, salesorder, salesorderapproval, purchaseorder, delivery, inventorytransfer, productstock, operationalcost, withdrawal, role, user, _id, processing, is_view } = state;

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">List Role</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <div className='table-responsive'>
                                <MTable ref={tableRoles} {...propsTable} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/** Modal detail */}
            <div id="modal-form" className='modal fade'>
                <Overlay display={processing} />
                <div className="modal-dialog modal-lg " style={{ marginTop: 100, maxWidth: 1000 }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">Role Detail</div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body" style={{ padding: 16 }}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="">Role Name</label>
                                        <input type="text" name="name" disabled={is_view} className="form-control" value={name} onChange={onNameChange} />
                                    </div>
                                </div>
                                <div className="col-md-1"></div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="">Active</label>
                                        <div>
                                            <InputSwitch name="is_active" checked={is_active} onChange={onSwitchChange} disabled={is_view} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="">Privileges</label>
                                    </div>
                                    <div className="form-group" style={{ border: 'solid 1px #ccc', borderRadius: 10, padding: 20 }}>
                                        <label htmlFor="">Menu</label>
                                        <div className="d-flex" style={{ flexWrap: 'wrap' }}>
                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10 }}>
                                                <Checkbox inputId='salesorder' checked={salesorder} onChange={onChange} name='salesorder' disabled={is_view} />
                                                <label htmlFor="salesorder" className='ml-2'>Sales Order</label>
                                            </div>
                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10 }}>
                                                <Checkbox inputId='salesorderapproval' checked={salesorderapproval} onChange={onChange} name='salesorderapproval' disabled={is_view} />
                                                <label htmlFor="salesorderapproval" className='ml-2'>Sales Order Approval</label>
                                            </div>
                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10 }}>
                                                <Checkbox inputId='purchaseorder' checked={purchaseorder} onChange={onChange} name='purchaseorder' disabled={is_view} />
                                                <label htmlFor="purchaseorder" className='ml-2'>Purchase Order</label>
                                            </div>
                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10 }}>
                                                <Checkbox inputId='delivery' checked={delivery} onChange={onChange} name='delivery' disabled={is_view} />
                                                <label htmlFor="delivery" className='ml-2'>Delivery</label>
                                            </div>
                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10 }}>
                                                <Checkbox inputId='inventorytransfer' checked={inventorytransfer} onChange={onChange} name='inventorytransfer' disabled={is_view} />
                                                <label htmlFor="inventorytransfer" className='ml-2'>Inventory Transfer</label>
                                            </div>
                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10, marginTop: 20 }}>
                                                <Checkbox inputId='operationalcost' checked={operationalcost} onChange={onChange} name='operationalcost' disabled={is_view} />
                                                <label htmlFor="operationalcost" className='ml-2'>Operational Cost</label>
                                            </div>
                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10, marginTop: 20 }}>
                                                <Checkbox inputId='productstock' checked={productstock} onChange={onChange} name='productstock' disabled={is_view} />
                                                <label htmlFor="productstock" className='ml-2'>Stock Ready</label>
                                            </div>
                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10, marginTop: 20 }}>
                                                <Checkbox inputId='withdrawal' checked={withdrawal} onChange={onChange} name='withdrawal' disabled={is_view} />
                                                <label htmlFor="withdrawal" className='ml-2'>Payment Gateway Withdrawal</label>
                                            </div>
                                        </div>
                                        <div className="mt-4"></div>
                                        <label htmlFor="">General Menu</label>
                                        <div className="d-flex" style={{ flexWrap: 'wrap' }}>

                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10 }}>
                                                <Checkbox inputId='user' checked={user} onChange={onChange} name='user' disabled={is_view} />
                                                <label htmlFor="user" className='ml-2'>User Management</label>
                                            </div>
                                            <div style={{ width: 200, display: 'flex', justifyItems: 'center', paddingTop: 10 }}>
                                                <Checkbox inputId='role' checked={role} onChange={onChange} name='role' disabled={is_view} />
                                                <label htmlFor="role" className='ml-2'>Role Management</label>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type='button' className='btn btn-outline-secondary' style={{ width: 150 }} data-dismiss="modal"><i className="fa fa-times"></i> Cancel</button>
                            {
                                (!is_view) && <button type='button' className='btn btn-dark' onClick={onSubmit} style={{ width: 150 }}><i className="fa fa-save"></i> Save</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RolePage